import styled, { css } from 'styled-components';
import { Link } from 'gatsby';

export const OverlayContainer = styled.div`
  ${({ theme }) => css`
    position: fixed;
    inset: 0;
    z-index: ${theme.zIndex.navbar + 10};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${theme.spacing.sm};
  `}
`;

export const Backdrop = styled.div<{ $isInteractive: boolean }>`
  ${({ theme, $isInteractive }) => css`
    position: absolute;
    inset: 0;
    background: ${theme.backgroundColors.dark}80;
    cursor: ${$isInteractive ? 'pointer' : 'default'};
  `}
`;

export const OverlayCard = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: min(100%, 37.5rem);
    max-width: 37.5rem;
    aspect-ratio: 1 / 1;
    padding: 16px;
    background: ${theme.colors.white};
    border-radius: ${theme.borderRadius.large};
    box-shadow: ${theme.shadows.normal};
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    box-sizing: border-box;
    z-index: 1;
    overflow: hidden;

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      padding: 12px;
      border-radius: ${theme.borderRadius.normal};
    }
  `}
`;

const linkStyles = css`
  display: block;
  width: 100%;
  height: 100%;
`;

export const OverlayAnchor = styled.a`
  ${linkStyles}
`;

export const OverlayGatsbyLink = styled(Link)`
  ${linkStyles}
`;

export const ImageWrapper = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: calc(${theme.borderRadius.large} - 0.5rem);
    overflow: hidden;

    .gatsby-image-wrapper,
    picture,
    img {
      width: 100%;
      height: 100%;
    }

    img {
      object-fit: cover;
    }
  `}
`;

export const CloseButton = styled.button`
  ${({ theme }) => css`
    position: absolute;
    top: 16px;
    right: 16px;
    width: 24px;
    height: 24px;
    border: none;
    background: rgba(7, 13, 25, 0.45);
    border-radius: 9999px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    z-index: 2;
    transition: background ${theme.transitions.short};

    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 60%;
      height: 2px;
      background: ${theme.colors.white};
      border-radius: 1px;
    }

    &::before {
      transform: rotate(45deg);
    }

    &::after {
      transform: rotate(-45deg);
    }

    &:hover {
      background: rgba(7, 13, 25, 0.65);
    }

    &:focus-visible {
      outline: 2px solid ${theme.colors.accent};
      outline-offset: 2px;
    }
  `}
`;
